import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsResultsList: build.query<
      ApiPortalV1AssessmentsResultsListApiResponse,
      ApiPortalV1AssessmentsResultsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/results/`,
        params: {
          aggregate_type: queryArg.aggregateType,
          assessment_period_id: queryArg.assessmentPeriodId,
          employee_id: queryArg.employeeId,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsResultsListApiResponse =
  /** status 200  */ AssessmentPeriodAggregateResultRead[];
export type ApiPortalV1AssessmentsResultsListApiArg = {
  aggregateType?: number;
  assessmentPeriodId?: number;
  employeeId?: number;
  organizationId?: number;
};
export type AggregateTypeEnum =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32;
export type AssessmentPeriodAggregateResult = {
  aggregate_type?: AggregateTypeEnum;
  result?: any;
  computed_version?: string | null;
  assessment_period: number;
};
export type AssessmentPeriodAggregateResultRead = {
  id: number;
  aggregate_type?: AggregateTypeEnum;
  result?: any;
  computed_version?: string | null;
  assessment_period: number;
};
export const { useApiPortalV1AssessmentsResultsListQuery } = injectedRtkApi;
